import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState, Fragment } from 'react';
import NumberFormat from 'react-number-format';
import ToolTip from '../../../components/Tooltip/Tooltip';
import classes from '../UnitEconomics.module.css';
import PercentTip from '../../../components/PercentTip/PercentTip';

const Churn = props => {
	const { churn, isLoading, clasificacion } = props;
	const nChurn = churn.nChurn;
	const nChurnPyme = churn.nChurnPyme;
	const nChurnCorp = churn.nChurnCorp;
	const totalBillChurn = churn.totalBillChurn;
	const totalBillChurnPyme = churn.totalBillChurnPyme;
	const totalBillChurnCorp = churn.totalBillChurnCorp;
	const percentChurn = churn.percentNChurn;
	const percentBillChurn = churn.percentBillChurn;
	const [monthYear, setMonthYear] = useState('');

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(churn.compareDate));
		}
	}, [isLoading, churn.compareDate]);

	return (
		<React.Fragment>
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<div className={classes.card}>
							<ToolTip
								text={
									'El churn rate es el porcentaje de $ que deja de percibir Rindegastos comparando 2 períodos en función de los clientes que abandonaron.'
								}
							/>
							<div className={classes.headerTitle}>Churn $</div>
							<div className={classes.date}>{monthYear}</div>
							{isLoading ? (
								<CircularProgress />
							) : (
								<div>
									<div className={classes.number}>
										<NumberFormat
											value={percentBillChurn * 100}
											displayType={'text'}
											thousandSeparator={true}
											suffix={'%'}
											decimalScale={0}
										/>
									</div>
									<br></br>
									<div className={classes.percentChurn}></div>
									{clasificacion ? (
										<Fragment>
											<div className={classes.percentChurn}>
												<PercentTip
													value={
														<NumberFormat
															value={totalBillChurn}
															displayType={'text'}
															thousandSeparator={true}
															prefix={'$'}
															decimalScale={0}
														/>
													}
													text={
														<Fragment>
															<div>Churn en $US</div>
														</Fragment>
													}
												/>
											</div>
										</Fragment>
									) : (
										<div className={classes.percentChurn}>
											<Grid container direction="row" justify="center" alignItems="center">
												<Grid container spacing={2}>
													<Grid item xs={4}>
														<PercentTip
															value={
																<NumberFormat
																	value={totalBillChurn}
																	displayType={'text'}
																	thousandSeparator={true}
																	prefix={'$'}
																	decimalScale={0}
																/>
															}
															text={
																<Fragment>
																	<div>Churn en $US</div>
																</Fragment>
															}
														/>
													</Grid>
													<Grid item xs={4}>
														<PercentTip
															value={
																<NumberFormat
																	value={(totalBillChurnPyme / totalBillChurn) * 100}
																	displayType={'text'}
																	decimalScale={2}
																	suffix={'%'}
																/>
															}
															text={
																<Fragment>
																	<div>$US Pyme</div>
																	<br></br>
																	<NumberFormat
																		value={totalBillChurnPyme}
																		displayType={'text'}
																		decimalScale={2}
																		prefix={'$'}
																	/>
																</Fragment>
															}
															pyme={true}
														/>
													</Grid>
													<Grid item xs={4}>
														<PercentTip
															value={
																<NumberFormat
																	value={(totalBillChurnCorp / totalBillChurn) * 100}
																	displayType={'text'}
																	decimalScale={2}
																	suffix={'%'}
																/>
															}
															text={
																<Fragment>
																	<div>$US Corp</div>
																	<br></br>
																	<NumberFormat
																		value={totalBillChurnCorp}
																		displayType={'text'}
																		decimalScale={2}
																		prefix={'$'}
																	/>
																</Fragment>
															}
															corp={true}
														/>
													</Grid>
												</Grid>
											</Grid>
										</div>
									)}
								</div>
							)}
						</div>
					</Grid>
					<Grid item xs={6}>
						<div className={classes.card}>
							<ToolTip text={'El churn rate es el porcentaje de Empresas que dejan Rindegastos comparando 2 períodos.'} />
							<div className={classes.headerTitle}>Churn en Empresas</div>
							<div className={classes.date}>{monthYear}</div>
							{props.isLoading ? (
								<CircularProgress />
							) : (
								<div>
									<div className={classes.number}>
										<NumberFormat
											value={percentChurn * 100}
											displayType={'text'}
											thousandSeparator={true}
											suffix={'%'}
											decimalScale={0}
										/>
									</div>
									<br></br>
									{clasificacion ? (
										<Fragment>
											<div className={classes.percentChurn}>
												<PercentTip
													value={
														<NumberFormat
															value={nChurn}
															displayType={'text'}
															thousandSeparator={true}
															decimalScale={0}
															prefix={'N: '}
														/>
													}
													text={
														<Fragment>
															<div>Número de empresas a las que aplica Churn</div>
														</Fragment>
													}
												/>
											</div>
										</Fragment>
									) : (
										<div className={classes.percentChurn}>
											<Grid container direction="row" justify="center" alignItems="center">
												<Grid container spacing={2}>
													<Grid item xs={4}>
														<PercentTip
															value={
																<NumberFormat
																	value={nChurnPyme + nChurnCorp}
																	displayType={'text'}
																	thousandSeparator={true}
																	decimalScale={0}
																/>
															}
															text={
																<Fragment>
																	<div>Número de empresas a las que aplica el Churn</div>
																</Fragment>
															}
														/>
													</Grid>
													<Grid item xs={4}>
														<PercentTip
															value={
																<NumberFormat
																	value={(nChurnPyme / nChurn) * 100}
																	displayType={'text'}
																	decimalScale={2}
																	suffix={'%'}
																/>
															}
															pyme={true}
															text={
																<Fragment>
																	<div>N empresas Pyme</div>
																	<br></br>
																	<NumberFormat value={nChurnPyme} displayType={'text'} decimalScale={2} />
																</Fragment>
															}
														/>
													</Grid>
													<Grid item xs={4}>
														<PercentTip
															value={
																<NumberFormat
																	value={(nChurnCorp / nChurn) * 100}
																	displayType={'text'}
																	decimalScale={2}
																	suffix={'%'}
																/>
															}
															corp={true}
															text={
																<Fragment>
																	<div>N empresas Corp</div>
																	<br></br>
																	<NumberFormat value={nChurnCorp} displayType={'text'} decimalScale={2} />
																</Fragment>
															}
														/>
													</Grid>
												</Grid>
											</Grid>
										</div>
									)}
								</div>
							)}
						</div>
					</Grid>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default React.memo(Churn);
